export default __webpack_public_path__ + "static/media/trashCan.ce97d7fd.svg";